import axios from 'axios';

/*
 * Per-domain notes / changes / follow-ups timeline (backend/domain_timeline.py).
 * Same base URL and bearer-token pattern as apiRankings.js. Writes throw (the
 * panel shows the server's detail); reads throw too, so a view can say so.
 */
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const base = (domainId) => `/domain/${encodeURIComponent(domainId)}/timeline`;

/* -> { domain_id, page, entries: [{ id, kind, text, scope, page, date, links, author, created_at, due_date?, status?, state }] }
   With page: that page's entries plus site-wide ones (and its old notes, copied on first read). */
export const getTimeline = async (domainId, { page } = {}) => {
  const response = await api.get(base(domainId), { params: page ? { page } : undefined });
  return response.data;
};

/* body: { text, kind, page?, date?, links?: [{url, label}], due_date?, follow_up?: {text, due_date} } -> { entry, follow_up? } */
export const createTimelineEntry = async (domainId, body) => {
  const response = await api.post(base(domainId), body);
  return response.data;
};

export const updateTimelineEntry = async (domainId, entryId, patch) => {
  const response = await api.patch(`${base(domainId)}/${encodeURIComponent(entryId)}`, patch);
  return response.data;
};

export const deleteTimelineEntry = async (domainId, entryId) => {
  const response = await api.delete(`${base(domainId)}/${encodeURIComponent(entryId)}`);
  return response.data;
};

/* -> { as_of, within_days, counts: { overdue, due, upcoming }, follow_ups: [entry + domain_name, state, days_until_due] } */
export const getFollowUpsDue = async (withinDays = 7) => {
  const response = await api.get('/timeline/follow-ups', { params: { within_days: withinDays } });
  return response.data;
};
